import { FiAlertTriangle } from "react-icons/fi";
import { hasPoorContrastWithWhite, isValidHexColor } from "../../theme/companyTheme";

export default function ThemeContrastWarning({ color, label = "This color" }) {
  if (!isValidHexColor(color) || !hasPoorContrastWithWhite(color)) {
    return null;
  }

  return (
    <div
      className="d-flex align-items-start gap-2 mt-2 p-2 rounded"
      style={{
        background: "#fcefe2",
        border: "1px solid #ff9500",
        fontSize: "13px",
        color: "#45464e",
      }}
      role="status"
    >
      <FiAlertTriangle aria-hidden="true" size={16} style={{ flex: "none", marginTop: 2 }} />
      <span>
        {label} may make white text difficult to read. Consider choosing a darker shade.
      </span>
    </div>
  );
}
